import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { DataTaskService } from '../../../core/services/data-task.service';

@Component({
  selector: 'tt-po-finish-prod-work',
  templateUrl: './po-finish-prod-work.component.html',
  styleUrls: ['./po-finish-prod-work.component.css']
})
export class PoFinishProdWorkComponent implements OnInit {
    p2PoPinishProdWorkKeyno;

    public menu?: Menu;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.p2PoPinishProdWorkKeyno = this.stateService.getStateParams()['p2_pofinishprodwork_keyno'];
    }

    private async loadMenu() {
        if (!!this.p2PoPinishProdWorkKeyno) {
            this.menu = (await this.datatask.Post(264, { p2_pofinishprodwork_keyno: this.p2PoPinishProdWorkKeyno }))[0];
        }
    }

    private async init() {
        this.loadMenu();
    }

    ngOnInit() {
        this.init();
    }
}

interface Menu {
    p2_pofinishprodwork_keyno: string;
    operation_name: string;
    calctime_hours: string;
    actualtime_hours: string;
    cost_pr_hour: string;
    actualtime_method: string;
    calctime_hours_pr_unit: string;
}
